enum Feature {
  BypassRealId = 'BypassRealId',
  LogRocket = 'LogRocket',
  WaitingRoomPage = 'WaitingRoomPage',
  ClientHints = 'ClientHints',
  ChimeVideo = 'ChimeVideo',
  InfoAlertNBTH = 'InfoAlertNBTH',
  NewSessionEndFailure = 'NewSessionEndFailure',
  AddUserToSession = 'AddUserToSession',
  MultiVideoStorageLocator = 'MultiVideoStorageLocator',
  NotaryCoach = 'NotaryCoach',
  ChimeMediaStatusCallbacks = 'ChimeMediaStatusCallbacks',
  ChimeEnhancedLogging = 'ChimeEnhancedLogging',
}

export { Feature };
